import React from 'react'
import { NavLink } from 'react-router-dom'
import { FooterConfig } from './config/FooterConfig'
import { useTranslation } from 'react-i18next'

export const AppFooter = () => {
    const { t } = useTranslation()

    return (
        <div className="app__footer d-flex justify-content-center">
            {FooterConfig.map(({ url, name, id, icon }) => {
                return (
                    <NavLink
                        key={id}
                        to={url}
                        className="app__footer__item d-flex flex-column align-items-center justify-content-center"
                        activeClassName="app__footer__item--active"
                    >
                        <span className="app__footer__item-icon">{icon}</span>
                        <span className="app__footer__item-name">{t(`navigation.${name.toLowerCase()}`)}</span>
                    </NavLink>
                )
            })}
        </div>
    )
}
